import type { PresetLabelTreeNode } from '@loc/server/interface/preset'

import ScrollArea from '@/pages/tad.ai/_components/ScrollArea'


import { cls } from 'tagged-classnames-free';
interface SubCategoryTabsProps {
  categories: PresetLabelTreeNode[]
  activeKey: string
  onChange: (key: string) => void
}

function SubCategoryTabs(props: SubCategoryTabsProps) {
  const { categories, activeKey, onChange } = props

  return (
    <div>
      <ScrollArea
        orientation='horizontal'
        scrollbarVisibility='hoverOrScroll'
        className={cls`border-f-border-secondary overflow-hidden border-b`}
      >
        <div className={cls`flex gap-5 pb-4`}>
          {categories.map((category) => {
            const isActive = activeKey === category.code
            return (
              <button
                key={category.code}
                type='button'
                className={cls`
                  relative shrink-0 cursor-pointer border-b-2 px-0 text-sm font-semibold transition-colors
                  ${isActive ? 'border-f-text text-f-text' : 'text-f-text-tertiary hover:text-f-text border-transparent'}
                `}
                onClick={() => onChange(category.code)}
              >
                {category.displayName}
              </button>
            )
          })}
        </div>
      </ScrollArea>
    </div>
  )
}

export default SubCategoryTabs
